// MIXIN for using Helpscout beacon 

// we make a helper object that holds a bunch of convenience methods for working with helpscout beacon
// then put that on the page as window.$helpscout or similar
// then in the mixin, just 'proxy' that through a computed
// you don't need each vue component to have its own instance of the helpscout helper object!

// Beacon developer docs:  https://developer.helpscout.com/beacon-2/web/javascript-api/

class HelpscoutHelper {
    constructor() {
        // because you are using window... you need to instantiate this on client side, not in main.js
        //this.beacon = beacon;  // THIS DOES NOT WORK AS EXPECTED - instead. just pass things to this.beacon() and call things on window.Beacon()
        this.currentUserInfo = window.currentUserInfo ?? {};
    }
    // make some helper methods
    beacon(...args) {
        // OTHER METHODS SHOULD JUST CALL THIS
        return window.Beacon(...args);
    }
    open() {
        this.beacon('open');
    }
    close() {
        this.beacon('close');
    }
    toggle() {
        this.beacon('toggle');
    }
    navigate(route) {
        // navigate to some route in the beacon - routes are limited/set by beacon 
        // must open beacon first or already be open 
        // routes:  /ask/  /ask/message/  /ask/chat/  /answers/   /previous-messages/   /docs/search?query=something
        this.beacon('navigate', route);
    }
    openAsk() {
        // ask includes both message (contact form) and chat, depending on who is available
        this.open();
        this.navigate('/ask/');
    }
    openChat() {
        // defaults to just ask if no chat available
        this.open();
        this.navigate('/ask/chat/');
    }
    openMessage() {
        this.open();
        this.navigate('/ask/message/');
    }
    openAnswers() {
        this.open();
        this.navigate('/answers/');
    }
    openPreviousMessages() {
        this.open();
        this.navigate('/previous-messages/');
    }
    openSearch(query) {  // query is optional
        this.open();
        const queryString = query ? `?query=${query}` : '';
        this.navigate(`/docs/search${queryString}`);
    }
    showMessage(msgId, force, delay) {
        // show an in-app message (different from support messages)
        if (!msgId) {
            console.warn('No message ID so cannot show HS Beacon message');
            return;
        }
        // do we need to open first??? try it if/when you start using messages
        const opts = {};
        if (force !== undefined) {
            opts['force'] = force;  // boolean, set true to show a message even if it has already been shown to specific customer
        }
        if (delay !== undefined) {
            opts['delay'] = delay;  // integer number of milliseconds to delay, if not using default of 3 seconds 
        }
        this.beacon('show-message', msgId, opts);
    }
}


let helpscoutBeaconMixin = {
    computed: {
        $beacon: function() {
            // return the Beacon() object for the Help Scout Beacon
            return window.Beacon;
        },
        $helpscout: function() {
            return window.helpscoutHelper;  // make sure you instantiate your HelpscoutHelper and set as this on window
        },
    },
};


export {
    HelpscoutHelper,
    helpscoutBeaconMixin,  // register this as a global mixin using Vue.mixin(helpscoutBeaconMixin) in main.js
}